import { Component, input } from '@angular/core';

@Component({
  selector: 'button[nttNavButton], a[nttNavButton]',
  templateUrl: './nav-button.html',
  styleUrl: './nav-button.scss',
  host: {
    '[class.ntt-nav-button--current]': 'current()',
    '[class.ntt-nav-button--lg]': 'size() === "lg"',
  },
})
export class NttNavButton {
  current = input(false);
  size = input<'md' | 'lg'>('md');
}
